import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    for: _ctx.id,
    class: "flex items-center cursor-pointer select-none"
  }, [
    _createElementVNode("input", {
      id: _ctx.id,
      type: "checkbox",
      checked: _ctx.modelValue,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.checked))),
      class: "base-checkbox h-5 w-5 rounded border-2 border-primary-purple focus:ring-primary-purple focus:ring-2 transition duration-150 ease-in-out mr-2"
    }, null, 40, _hoisted_2),
    _createElementVNode("span", {
      class: _normalizeClass(['text-base font-medium text-gray-700', _ctx.labelClass])
    }, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(_ctx.label), 1)
      ])
    ], 2)
  ], 8, _hoisted_1))
}